import active_main_filter from "./active-main-filter.json";
import recurring_transaction from "./recurring-transaction.json";
import recurring_movement from "./recurring-movement.json";
import archived_transaction from "./archived-transaction.json";
import recycled_transaction from "./recycled-transaction.json";
import fields_validation from "./fields-validation.json";
import not_found_account from "./not-found-account.json";
import inactive_accounts from './inactive-accounts.json'

export default {
  active_main_filter,
  recurring_transaction,
  recycled_transaction,
  archived_transaction,
  recurring_movement,
  fields_validation,
  not_found_account,
  inactive_accounts
};
